'use client'

import fileSizeUnit from '@/utils/fileSizeUnit'
import MediaSkeleton from '@/components/shared/loaders/MediaSkeleton'
import FileIcon from '@/components/view/FileIcon'
import { TbCloudDownload } from 'react-icons/tb'
import { Button } from '@/components/ui'

type FileSegmentProps = {
    fileType?: string
    size?: number
    name?: string
    srcUrl: string
    loading?: boolean
}

const FileSegment = ({
    fileType,
    size,
    name,
    srcUrl,
    loading,
}: FileSegmentProps) => {
    return (
        <div className="bg-white rounded-2xl dark:bg-gray-800 border border-gray-200 py-4 px-3.5 flex items-center justify-between gap-2">
            {loading ? (
                <MediaSkeleton />
            ) : (
                <>
                    <div className="flex items-center gap-3">
                        <div className="text-3xl">
                            <FileIcon type={fileType || ''} />
                        </div>

                        <div>
                            <div className="font-bold">{name}</div>
                            <span className="text-xs text-gray-500">
                                {fileSizeUnit(size || 0)}
                            </span>
                        </div>
                    </div>

                    <a
                        href={srcUrl}
                        download
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <Button className="flex gap-2 items-center bg-black text-white">
                            <TbCloudDownload className="text-xl" />
                            <span className="text-base">Скачать</span>
                        </Button>
                    </a>
                </>
            )}
        </div>
    )
}

export default FileSegment
